import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils";
import AddAccountModel from "../../Modals/AddAccountModel";
import {
  Button,
  DropdownMenuNew,
  LogoLoader,
  showToast,
  TableAdv,
} from "../../../../../components";
import { usePagination } from "../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  deleteIntegration,
  getAllIntegrations,
  updateIntegrations,
} from "../../../../../redux/slices/setting/settingApi";
import {
  deleteIntegrationBs,
  getAllIntegrationsBs,
  updateIntegrationsBs,
  updateIntegrationsBsMail,
} from "../../../../../redux/slices/ats/benchSales/benchSalesApi";
import AddUsersListModel from "../../Modals/AddUsersListModel";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { getAllIntegrationsNm, updateIntegrationsNm } from "../../../../../redux/slices/nonitMarketing/nonitMarketingApi";

const ProductivityAccounts = ({
  category,
  type,
  integrations,
  onUpdate,
  selectedModule,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [integrationData, setIntegrationData] = useState([]);
  const [integrationAccess, setIntegrationAccess] = useState({});
  const [editData, setEditData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valueChange, setValueChange] = useState(false);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const integrationKey = `${category}-${type}`;
  const integration = integrations[integrationKey];
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.GoogleIntegrationCount?.data || 0;

  const tableColumn = [
    {
      key: "actions",
      label: "",
      columnMenu: false,
      render: (row) => (
        <DropdownMenuNew
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Add Users"}
                icon={"group_add"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setEditData(integrationData[row.id]);
                  setIsModalOpen(true);
                }}
              />

              <Button
                title={"Edit"}
                icon={"edit_square"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setShowConnectModal(true);
                  setEditData(integrationData[row.id]);
                  setIsEdit(true);
                }}
              />

              {/* <Button             //CONFIRMED WITH MOHSIN
                title={"Delete"}
                icon={"delete"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => handleDelete(row.uiid)}
              /> */}
            </div>
          }
        >
          <Button
            type="icon"
            variant="text"
            icon={"more_vert"}
            color="black"
            label="true"
          />
        </DropdownMenuNew>
      ),
    },
    {
      key: "accountName",
      label: "Account Name",
      columnMenu: false,
    },
    { key: "displayName", label: "Display Name", columnMenu: false },
    { key: "noofUsers", label: "No of Users", columnMenu: false },
    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={row.status === 1 ? "toggle_on" : "toggle_off"}
            color={row.status === 1 ? "success" : "black"}
            // icon={"toggle_on"}
            // color={toggleOn.includes(row.id) ? "success" : "color"}
            // color="black"
            size="sm"
            onClick={() =>
              toggleIntegrationAccess(row.uiid, row.status === 1 ? 2 : 1)
            }
            // onClick={() => handleStatusToggle(row)}
          />
        </div>
      ),
    },
    // {
    //   key:"menu",
    //   label:"",
    //   columnMenu:false,
    //   render:(row)=>(
    //       <div className="text-center text-xl cursor-pointer hover:text-gray-600">
    //     ⋯
    //   </div>
    // ),

    // }
  ];

  const handleSave = (data) => {
    onUpdate(data, () => {
      fetchIntegrationData();
    });
    setShowConnectModal(false);
    // setShowTable(true);
  };

  const getServiceName = () => {
    const configs = {
      7: { 1: "Google Search API", 2: "Apollo" },
    };
    return configs[category]?.[type] || "Service";
  };

  const serviceName = getServiceName();

  // useEffect(() => {
  //   if (location.state?.showTable === true) {
  //     setShowTable(true);
  //   }
  // }, [location.state]);

  const fetchIntegrationData = async () => {
    const params = {
      coll: selectedModule === "bs" || selectedModule === "nm" ? "Integrationbs" : "Integration",
      fil: JSON.stringify({
        category: { type: "NONE", value: category },
        type: { type: "NONE", value: type },
      }),
      lim: limit,
      pg: page,
    };
    try {
      setLoading(true);
      const response =
        selectedModule === "bs"
          ? await getAllIntegrationsBs(params)
          :     selectedModule === "nm"
        ? await getAllIntegrationsNm(params):await getAllIntegrations(params);
      if (response?.success) {
        const list = response.data?.data || [];
        // console.log("list", list)

        const accessMap = list.reduce((acc, item) => {
          acc[item.uiid] = item.status;
          return acc;
        }, {});

        setIntegrationData(list);
        setIntegrationAccess(accessMap);
      } else {
        console.log("Unable to fetch integration Data", response?.msg);
        setIntegrationData([]);
      }
    } catch (error) {
      showToast("Unable to fetch integration Data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIntegrationData();
  }, [category, type, selectedModule]);

  const handleDelete = async (uiid) => {
    // console.log("uiid",uiid)
    if (!uiid) return;
    try {
      const response =
        selectedModule === "bs"
          ? await deleteIntegrationBs({ uiid, coll: "Integrationbs" })
          : await deleteIntegration({ uiid, coll: "Integration" });

      if (response?.success) {
        showToast("Integration deleted successfully", "success");
        fetchIntegrationData();
      } else {
        showToast("Failed to delete integration", "error");
      }
    } catch (error) {
      console.warn("Error while deleting integration: ", error);
      showToast("Failed to delete integration", "error");
    }
  };

  const toggleIntegrationAccess = async (uiid, status) => {
    const newintegrationAccess = { ...integrationAccess, [uiid]: status };

    try {
      const payload = [
        {
          type: "SET",
          value: { status },
        },
      ];
      setLoading(true);
      const updateStatus =
        selectedModule === "bs"
          ? await updateIntegrationsBs({ uiid, payload })
          : selectedModule === "nm"
          ? await updateIntegrationsNm({ uiid, payload }):await updateIntegrations({ uiid, payload });

      if (updateStatus?.success) {
        setIntegrationAccess(newintegrationAccess);
        showToast("Integration status updated successfully", "success");
        setLoading(false);
      } else {
        showToast("Failed to update Integration status", "error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating integration status:", err);
      showToast("Failed to update Integration status", "error");
      setLoading(false);
    }
  };

  const categoryTypes = {
    7: {
      1: "Google Search API",
      2: "Apollo",
    },
  };

  const rowDat = Array.from({ length: integrationData?.length }, (_, i) => ({
    id: i,
    accountName: categoryTypes[category]?.[type] || "-",
    displayName: formatWords2(integrationData?.[i]?.name) || "-",
    noofUsers: integrationData?.[i]?.accessIds?.length || "-",
    access: `User ${i + 1}`,
    uiid: integrationData?.[i]?.uiid,
    status: integrationAccess[integrationData?.[i]?.uiid],
  }));

  const mappedrows = mapTableRows(rowDat, tableColumn);

  if (selectedModule === "bs" && type === 1) {
    return (
      <div className="mt-3">
        <p>
          This feature is not available for Bench Sales. However, you can
          configure the following features:
        </p>
        <div className="ms-3">
          <h6 className="text-dark my-2 -ms-1">
            Available Features for Bench Sales:
          </h6>
          <p>
            1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt;
            Kult AI (Text) &gt; Setup / Configure
          </p>
          <p>
            2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt;
            Apollo &gt; Setup / Configure
          </p>
          <p>
            3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt;
            G-Suite &gt; Setup / Configure
          </p>
          <p>
            4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt;
            Outlook &gt; Setup / Configure
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {!integrationData || integrationData?.length <= 0 ? (
        <>
          <div className="flex justify-end items-center gap-2 mb-1">
            {/* <div className="w-[120px]">
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="sm"
            options={[
              { label: "Monster", value: 1 },
              { label: "Foundit", value: 2 },
              { label: "Linkedin", value: 3 },
              { label: "Naukri", value: 4 },
              { label: "Jora", value: 5 },
              { label: "Career Builder", value: 6 },
            ]}
            shadow={true}
          />
        </div> */}
            <Button
              title={`Connect ${serviceName}`}
              size="sm"
              onClick={() => setShowConnectModal(true)}
            />
          </div>
          <p>
            Integration with {serviceName} for resume search is a
            straightforward process through Tektree Inc. Follow these steps.
          </p>
          <div className="font-bold mt-5 mb-2">
            Here are the steps to configure the Integrations
          </div>
          <ol className="list-decimal list-inside">
            <li>
              Contact your {serviceName} Account Manager to initiate the
              process.
            </li>
            <li>Request the necessary credentials.</li>
            <li>
              Click on <b>"Connect {serviceName}"</b> and provide the necessary
              details.
            </li>
            <li>
              Save the entered information to add your account successfully.
            </li>
            <li>
              Once saved, you can allocate credits to your team for utilization.
            </li>
            <li>
              Get ready to find top talent with {serviceName}'s extensive
              network and tools.
            </li>
          </ol>
        </>
      ) : (
        // : loading ? (
        //   <div className="flex-1 flex justify-center items-center">
        //     <LogoLoader />
        //   </div>
        // )
        <TableAdv
          tableId={`ats_marketplace_productivitytabs_${type}_table`}  
          columns={tableColumn}
          rows={mappedrows}
          showSlNo={false}
          showCheckbox={false}
          serverPagination={false}
          isLoading={loading}
          //   totalCount={totalCount}
          //   page={page}
          //   limit={limit}
          //   onPaginationChange={setPage}
          //   onLimitChange={handleLimitChange}
          toolbarRight={{
            search: false,
            fullScreen: true,
            add: [
              {
                component: (
                  <Button
                    title={"Add Account"}
                    size="sm"
                    onClick={() => {
                      setShowConnectModal(true);
                      setEditData();
                      setIsEdit(false);
                    }}
                  />
                ),
              },
            ],
          }}
        />
      )}

      <AddAccountModel
        isOpen={showConnectModal}
        onClose={() => setShowConnectModal(false)}
        category={category}
        type={type}
        existingData={editData ? editData : null}
        // existingData={integration}
        // onSave={onUpdate}
        onSave={handleSave}
        // isEditMode={!!integration}
        isEditMode={isEdit}
        selectedModule={selectedModule}
      />
      <AddUsersListModel
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          fetchIntegrationData();
        }}
        showConnectModal={() => setShowConnectModal(true)}
        onValueChange={(val) => setValueChange(val)}
        integrationId={editData ? editData?.uiid : null}
        category={category}
        type={type}
        selectedModule={selectedModule}
      />
      {/* <AddBulkList
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        showConnectModal={() => setShowConnectModal(true)}
      /> */}
    </div>
  );
};

export default ProductivityAccounts;
